import { render } from "./TopbarPrivacyModeToggle.vue?vue&type=template&id=298ec34f&scoped=true"
import script from "./TopbarPrivacyModeToggle.vue?vue&type=script&lang=js"
export * from "./TopbarPrivacyModeToggle.vue?vue&type=script&lang=js"

import "./TopbarPrivacyModeToggle.vue?vue&type=style&index=0&id=298ec34f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298ec34f"]])

export default __exports__